var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64167 2.95599C4.85138 1.90776 6.399 1.33176 7.99967 1.33399C11.6817 1.33399 14.6663 4.31866 14.6663 8.00066C14.6663 9.42466 14.2197 10.7447 13.4597 11.8273L11.333 8.00066H13.333C13.3331 6.95507 13.0258 5.93253 12.4495 5.06016C11.8731 4.1878 11.053 3.5041 10.0911 3.09407C9.12929 2.68405 8.06815 2.56579 7.03965 2.754C6.01114 2.94221 5.06064 3.42859 4.30634 4.15266L3.64167 2.95599ZM12.3577 13.0453C11.148 14.0935 9.60035 14.6696 7.99967 14.6673C4.31767 14.6673 1.33301 11.6827 1.33301 8.00066C1.33301 6.57666 1.77967 5.25666 2.53967 4.17399L4.66634 8.00066H2.66634C2.66626 9.04624 2.97351 10.0688 3.5499 10.9412C4.12629 11.8135 4.94639 12.4972 5.90822 12.9072C6.87006 13.3173 7.9312 13.4355 8.9597 13.2473C9.98821 13.0591 10.9387 12.5727 11.693 11.8487L12.3577 13.0453Z",
    fill: "#1B75BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.74174146c612776b9bf009d9b635477b.svg";
export { ForwardRef as ReactComponent };